module.exports = __webpack_public_path__ + "facebook-icon-small-8b626bab65780c1f646034c8838d0542.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/social-medias/facebook-icon-small.svg
// module id = 91
// module chunks = 0